import { render, staticRenderFns } from "./DeActivateUser.vue?vue&type=template&id=599fed92&"
import script from "./DeActivateUser.vue?vue&type=script&lang=js&"
export * from "./DeActivateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports